import React from 'react';
import PropTypes from 'prop-types';
import { GlobalErrorBoundary } from '@bingads-webui-react/global-error-boundary';
import { withErrorOptions } from './with-error-boundary-options';

export const withErrorView = (WrappedComponent, errorViewMode) => {
  const ErrorView = ({ errorOptions, ...props }) => (
    <GlobalErrorBoundary
      {...errorOptions}
    >
      <WrappedComponent
        {...props}
      />
    </GlobalErrorBoundary >
  );

  ErrorView.propTypes = {
    errorOptions: PropTypes.shape({
      logError: PropTypes.func.isRequired,
    }).isRequired,
  };

  return withErrorOptions(ErrorView, errorViewMode);
};
